import Vue from 'vue';
import { Cart, Customer, StoreConf } from 'yf-commerce-model-ui-lib';

export class State {

	user?: Customer = undefined;
	cart?: Cart = undefined;
	shopConf?: StoreConf = undefined;

	reset() {
		this.user = undefined;
		this.cart = undefined;
	}
}

export default Vue.observable(new State());
